// React
import { FunctionComponent, useState } from "react"

// UI Library
import { Modal, Spinner } from "react-bootstrap"

// Shared Components
import CreateApprovalWF from "src/components/approvals/components/CreateApprovalWF/CreateApprovalWF"
import approvalService from "src/components/approvals/ApprovalService"

// Local Components
import VehicleIncidentsMiniInfo from "../VehicleIncidentsMiniInfo/VehicleIncidentsMiniInfo"

// Interfaces
import { I_IncidentAction } from "../../interfaces"

// Services
import VIS from "../../VehicleIncidentsService"

// Constants
import { SAFETY_EVENT_RECORD_TYPE_ID, getTemplateGroupId } from "../../constants/VehicleIncidentsApprovalConfig"

// Styles
import "./VehicleIncidentsInitReview.css"

interface Props {
    incidentAction: I_IncidentAction
}

// Modal for starting an approval workflow for a new vehicle incident
const VehicleIncidentsInitReview: FunctionComponent<Props> = ({ incidentAction }) => {
    const { getAllowedReviewersForForm, retrieveEventFromMap, setIncidentAction, refresh } = VIS

    const event = retrieveEventFromMap(incidentAction.id || -1)
    const [busy, setBusy] = useState(false)

    if (!event) return null

    const { EmployeeID, ObjectID } = event

    const handlePostCreateActions = async () => {
        setIncidentAction({
            action: 0,
            id: -1
        })
        await refresh(VIS.currentView)
    }

    return (
        <div className="VehicleIncidentsInitReview">
            <Modal
                id="vehicle-incidents-init-review-modal"
                show
                backdrop="static"
                keyboard
                centered
                className="VehicleIncidentsWorkflowModal"
                animation={false}
            >
                <Modal.Header>
                    <div className="VehicleIncidentsInitReviewHeader VehicleIncidentsWorkflowModalHeader">
                        <p>Start review process</p>
                        {busy && <Spinner
                            className="VehicleIncidentsWorkflowModalHeaderSpinner"
                            animation="border"
                        />}
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <div className="VehicleIncidentsInitReviewModalBody">
                        <div className="VehicleIncidentsInitReviewModalBodyUpper">
                            <VehicleIncidentsMiniInfo
                                id={incidentAction.id}
                            />
                        </div>
                        <div className="VehicleIncidentsInitReviewModalBodyLower">
                            <CreateApprovalWF
                                recordTypeId={SAFETY_EVENT_RECORD_TYPE_ID}
                                recordId={ObjectID}
                                employeeId={EmployeeID}
                                templateGroupId={getTemplateGroupId(approvalService.reference)}
                                allowedReviewers={getAllowedReviewersForForm()}
                                finishedCallback={handlePostCreateActions}
                                cancelCallback={() =>
                                    setIncidentAction({
                                        action: 1,
                                        id: incidentAction.id
                                    })
                                }
                                closeBtnText="Back"
                                setLoading={() => setBusy(true)}
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default VehicleIncidentsInitReview

